import { css } from '@emotion/core';
import styled from '@emotion/styled';

const wrapperStyles = ({
  theme: {
    grid: { breakpoint },
  },
}) => css`
  margin-top: 50px;
  margin-bottom: 20px;
  ${breakpoint.fromTablet} {
    margin-top: 80px;
    margin-bottom: 50px;
  }
  ${breakpoint.fromDesktop} {
    margin-top: 120px;
    margin-bottom: 70px;
  }
`;

const blogListingStyles = ({
  theme: {
    grid: { breakpoint },
  },
}) => css`
  ${breakpoint.toTablet} {
    margin-left: -15px;
    margin-right: -15px;
  }
`;

/**
 * Component style declarations
 */
export const Wrapper = styled('div')(wrapperStyles);
export const BlogList = styled('div')(blogListingStyles);
